import React from "react";

const TextBtn = ({ children, active = false, ...props }) => (
  <button {...props} className={`mx-1 hover:text-gray-600 font-bold bg-white ${active ? "text-primary-500" : "text-gray-600/75"}`}>
    {children}
  </button>
);

export default TextBtn;
